<p>help-common-complete works!</p>
